export const listReport = {
  table: {
    date: 'Date',
    total: 'Total',
    reset: 'Reset',
    export: 'Export',
    hour: '(unit　ｈ)',
    id: 'History ID',
    addTag: 'Add tag',
    customerId: 'Customer ID',
    customerCode: 'Customer Code',
    customerName: 'Customer Name',
    operatorCode: 'Operator Code',
    operatorName: 'Operator Name',
    washingMachineId: 'Washing Machine ID',
    washingMachineName: 'Washing Machine Name',
    washingMethodName: 'Washing Method',
    startDateTime: 'Start Time',
    endDateTime: 'End Time',
    duration: 'Duration (minutes)',
    washingTime: 'Washing Time',
    washingMethod: 'Washing Method',
    laundryWeight: 'Laundry Weight/%',
    detergentCost: 'Detergent cost/1w',
    hydroKleanUsedPerGram: 'HK/g',
    rinseWaterPerMl: 'Rinse Water (ml)',
    volumes: 'Volume (L)',
    totalPrice: 'Total Price',
    detergents: 'Detergents',
    totalWaterUsed: 'Total Water Used (L)',
    totalUsage: 'Total Usage',
    usagePerCapacity: 'Usage / Capacity',
    amount: 'Amount',
    unitPrice: 'Unit Price',
    machineCode: 'Machine Code',
    water: 'Water',
    action: 'Action',
  },
  pageHeader: {
    title: 'Washing History management',
  },
  filter: {
    filterDay: 'View by date',
    filterByRangeDay: 'View by range date',
    filterByTime: 'View by specifying period',
    filterCustomerName: 'Customer',
    filterOperator: 'Operator',
    filterMachine: 'Machine',
  },
  modal: {
    title: 'Create laundry',
    washingMachine: 'Machine name',
    customerName: 'Customer name',
    operatorName: 'Operator name',
    washingMethod: 'Washing method',
    volume: 'Volume',
    time: 'Time',
    submit: 'Submit',
    requireWashingMachine: 'Please input machine',
    requireCustomerName: 'Please input customer',
    requireOperatorName: 'Please input operator',
    requireWashingMethod: 'Please input washing method',
    requireVolume: 'Please input volume',
    requireTime: 'Please input time',
  },
  hooks: {
    selectRangeDateFail: 'Range date invalid',
  },
}
